import { cn } from '@/lib/utils';

type BrandLogoVariant = 'icon' | 'on-light' | 'on-dark' | 'adaptive';

interface BrandLogoProps {
  variant?: BrandLogoVariant;
  className?: string;
  label?: string;
}

const LOGO_SOURCES = {
  icon: '/Icon.svg',
  'on-light': '/logo_light_bg.svg',
  'on-dark': '/logo_dark_bg.svg',
} as const;

/**
 * Shared brand artwork. The adaptive variant follows the app's data-theme
 * attribute without waiting for JavaScript to choose an asset.
 */
export function BrandLogo({
  variant = 'adaptive',
  className,
  label = 'ZAAG Social',
}: BrandLogoProps) {
  if (variant !== 'adaptive') {
    return (
      <span
        className={cn('brand-logo', className)}
        role={label ? 'img' : undefined}
        aria-label={label || undefined}
        aria-hidden={label ? undefined : true}
      >
        <img src={LOGO_SOURCES[variant]} alt="" aria-hidden="true" />
      </span>
    );
  }

  return (
    <span
      className={cn('brand-logo brand-logo--adaptive', className)}
      role={label ? 'img' : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
    >
      <img
        className="brand-logo__on-light"
        src={LOGO_SOURCES['on-light']}
        alt=""
        aria-hidden="true"
      />
      <img
        className="brand-logo__on-dark"
        src={LOGO_SOURCES['on-dark']}
        alt=""
        aria-hidden="true"
      />
    </span>
  );
}
